import React from 'react';

const DivSession = ({ children }) => {
  return (
    <div className="h-full overflow-y-auto  sm:pb-5 z-0">
      <div className="flex flex-col gap-4 justify-center w-full  items-center ">{children}</div>
    </div>
  );
};

export default DivSession;
